<!--
 *                   ___====-_  _-====___
 *             _--^^^#####//      \\#####^^^--_
 *          _-^##########// (    ) \\##########^-_
 *         -############//  |\^^/|  \\############-
 *       _/############//   (@::@)   \############\_
 *      /#############((     \\//     ))#############\
 *     -###############\\    (oo)    //###############-
 *    -#################\\  / VV \  //#################-
 *   -###################\\/      \//###################-
 *  _#/|##########/\######(   /\   )######/\##########|\#_
 *  |/ |#/\#/\#/\/  \#/\##\  |  |  /##/\#/  \/\#/\#/\#| \|
 *  `  |/  V  V  `   V  \#\| |  | |/#/  V   '  V  V  \|  '
 *     `   `  `      `   / | |  | | \   '      '  '   '
 *                      (  | |  | |  )
 *                     __\ | |  | | /__
 *                    (vvv(VVV)(VVV)vvv)
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                神兽保佑            永无BUG
 * 
 * @Author: 路守恒
 * @LastEditors: 路守恒
 * @Date: 2021-12-28 15:15:11
 * @LastEditTime: 2021-12-31 18:02:42
 * @FilePath: \news2021\src\components\desc.vue
 * @Description: 
 -->
<template>
  <div class="wrap">
    <div>
      <div v-for="(item, index) in menuList" :key="index">
        <img :src="item.menuBg" class="wrap-bg" v-if="item.active" />
      </div>

      <div class="wrap-mask"></div>
    </div>

    <el-row>
      <el-col
        :span="7"
        style="
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 30px;
        "
      >
        <ul class="wrap-menu">
          <li v-for="(item, index) in menuList" :key="index">
            <i
              @click="menuClick(item, index)"
              :class="{ active: item.active }"
            ></i>
            <p @click="menuClick(item, index)" :class="{ active: item.active }">
              {{ item.menuTitle }}
            </p>
          </li>
        </ul>
      </el-col>
      <el-col :span="10">
        <full-page :options="options" id="fullpage" ref="fullpage">
          <div class="section" v-for="(item, index) in menuList" :key="index">
            <div class="section-top">
              <div class="section-top-left">
                <h5>{{ item.menuName }}</h5>
                <h1 v-text="item.menuTitle"></h1>
              </div>
              <img
                src="../assets/img/desc-title.png"
                class="section-top-right"
              />
            </div>
            <el-carousel
              :interval="4000"
              :height="bannerHeight + 'px'"
              type="card"
              :autoplay="false"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(carouselItem, carouselIndex) in item.carousel"
                :key="carouselIndex"
              >
                <el-image
                  ref="img_ref"
                  @load="imgLoad"
                  class="carousel-img"
                  :src="carouselItem.img"
                  :preview-src-list="[
                    item.carousel[0].imgBig,
                    item.carousel[1].imgBig,
                    item.carousel[2].imgBig,
                    item.carousel[3].imgBig,
                    item.carousel[4].imgBig
                  ]"
                >
                </el-image>
              </el-carousel-item>
            </el-carousel>
            <p class="section-intro" v-html="item.menuIntro"></p>
            <Xgplayer
              :config="{
                id: `vs${index}`,
                lang: 'zh-cn',
                controls: true,
                autoplay: false,
                playbackRate: [0.5, 0.75, 1, 1.5, 2],
                defaultPlaybackRate: 1,
                videoInit: true,
                fluid: true,
                fitVideoSize: 'fixHeight'
              }"
              :playUrl="item.playUrl"
            />
          </div>
        </full-page>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Xgplayer from './xgplayer-vue.vue'
export default {
  components: {
    Xgplayer
  },
  data() {
    return {
      bannerHeight: '',
      Player: null,
      options: {
        licenseKey: 'GNU GENERAL PUBLIC LICENSE',
        onLeave: (index, nextIndex) => {
          this.menuList[index.index].active = false
          this.menuList[nextIndex.index].active = true
        },
        anchors: [
          'SpringFestival',
          'LanternFestival',
          'ChingMingFestival',
          'DragonBoatFestival',
          'JulySeventhDay',
          'Mid-AutumnFestival',
          'ChungYeungFestival'
        ]
      },
      menuList: [
        {
          menuTitle: 'Spring Festival',
          menuName: '春节',
          menuIntro: `The first day of the first month in the lunar calendar is the Spring Festival, which is called Chinese New Year. This is the most important festival of the year, which has a history of more than 4,000 years in China and is also a common holiday for many Eastern countries and Asian immigrants. During this festival, most Chinese will rush home from different places to reunite with their families and send the best wishes to their relatives and friends.<br /><br />There are many customs during this Festival. In 2021, the New Year’s Gala produced by Henan Broadcasting System became popular, and Tang Palace Banquet was loved by audiences all over the world.`,
          active:
            this.$route.params.tabListTitle === 'SpringFestival' ? true : false,
          menuBg: 'https://static.hntv.tv/total/jrxl/desc/SpringFestival.jpg',
          playUrl:
            'https://media2.hntv.tv/data_01/1/3/2021/12/29/e2099a4cfea623c8072993516d080b0a.mp4',
          carousel: [
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/1.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/big/1.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/2.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/big/2.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/3.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/big/3.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/4.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/big/4.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/5.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/SpringFestival/big/5.jpg`
            }
          ]
        },
        {
          menuTitle: 'Lantern Festival',
          menuName: '元宵节',
          menuIntro: `The 15th day of the first lunar month is the Lantern Festival, which is the first full-moon night after the Spring Festival. During the Lantern Festival, people will eat sweet sticky rice dumplings, watch lantern show and hold a lively celebration. In 2021, the Lantern Festival gala, Wonderful Night of Lantern Festival, produced by Henan Broadcasting System, tells the story of a group of cultural relics of Tang Dynasty travel in modern Henan during the Lantern Festival.`,
          active:
            this.$route.params.tabListTitle === 'LanternFestival'
              ? true
              : false,
          menuBg: 'https://static.hntv.tv/total/jrxl/desc/LanternFestival.jpg',
          playUrl:
            'https://media2.hntv.tv/data_01/1/3/2021/09/11/779774feb3c384cce57d7ade2a79621d.mp4',
          carousel: [
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/1.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/big/1.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/2.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/big/2.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/3.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/big/3.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/4.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/big/4.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/5.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/LanternFestival/big/5.jpg`
            }
          ]
        },
        {
          menuTitle: 'Ching Ming Festival',
          menuName: '清明节',
          menuIntro: `Ching Ming is one of the twenty-four solar terms, with a history of more than 2000 years. People often travel in the suburbs together on this day to appreciate the spring scenery. Ching Ming Festival is also a festival to worship ancestors. In 2021, under the leadership of Tang graceful ladies, the Wonderful Tour of Ching Ming gala, produced by Henan Broadcasting System, shows splendid Henan scenery to audiences.`,
          active:
            this.$route.params.tabListTitle === 'ChingMingFestival'
              ? true
              : false,
          menuBg:
            'https://static.hntv.tv/total/jrxl/desc/ChingMingFestival.jpg',
          playUrl:
            'https://media2.hntv.tv/data_01/1/3/2021/12/29/bb62ca1eee68d615e779561778841c2f.mp4',
          carousel: [
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/1.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/big/1.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/2.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/big/2.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/3.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/big/3.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/4.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/big/4.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/5.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChingMingFestival/big/5.jpg`
            }
          ]
        },
        {
          menuTitle: 'Dragon Boat Festival',
          menuName: '端午节',
          menuIntro: `The fifth day of the fifth month in the lunar calendar is the Dragon Boat Festival. In ancient Chinese theories, it has the most yang spirit during the Dragon Boat Festival which has led to many customs. <br /><br />The Dragon Boat Festival has affected many countries and regions and also become the intangible cultural heritage of mankind. In 2021, the Wonderful Tour of Dragon Boat Festival gala, has wowed internet users with its ingenious recreation of the Goddess of Luo River.  `,
          active:
            this.$route.params.tabListTitle === 'DragonBoatFestival'
              ? true
              : false,
          menuBg:
            'https://static.hntv.tv/total/jrxl/desc/DragonBoatFestival.jpg',
          playUrl:
            'https://media2.hntv.tv/data_01/1/3/2021/10/01/20762c74fb3c1cfe708c84c83f645eb6.mp4',
          carousel: [
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/1.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/big/1.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/2.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/big/2.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/3.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/big/3.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/4.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/big/4.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/5.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/DragonBoatFestival/big/5.jpg`
            }
          ]
        },
        {
          menuTitle: 'July Seventh Day',
          menuName: '七夕节',
          menuIntro: `The seventh night of the seventh month of the lunar calendar is called "Qixi", which is derived from the ancient Chinese yearning for the starry sky. In Chinese legends, the Cowboy and the Lady will meet on this day every year, so it is also regarded as China's "Valentine's Day". In addition to the display of love and traditional folklore, Wonderful Tour of Qixi gala, produced by Henan Broadcasting System in 2021, also praises the dream of traveling in space.`,
          active:
            this.$route.params.tabListTitle === 'JulySeventhDay' ? true : false,
          menuBg: 'https://static.hntv.tv/total/jrxl/desc/JulySeventhDay.jpg',
          playUrl:
            'https://media2.hntv.tv/data_01/1/3/2021/08/13/d6a3428cb126b4821f63f88e994c63c4.mp4',
          carousel: [
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/1.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/big/1.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/2.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/big/2.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/3.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/big/3.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/4.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/big/4.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/5.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/JulySeventhDay/big/5.jpg`
            }
          ]
        },
        {
          menuTitle: 'Mid-Autumn Festival',
          menuName: '中秋节',
          menuIntro: `The fifteenth day of the eighth lunar month is the Mid-Autumn Festival. For the Mid-Autumn Festival, people always use the full moon to signify the reunion, to carry affection and pray for harvest and happiness. <br /><br />The Mid-Autumn Festival is also important festivals in Japan, South Korea, Vietnam and some countries in Southeast Asia. The gala of The Wonderful Tour of Mid-Autumn Festival, with a large number of intangible cultural elements, reproduced the spectacular event of the Mid-Autumn Festival. `,
          active:
            this.$route.params.tabListTitle === 'Mid-AutumnFestival'
              ? true
              : false,
          menuBg:
            'https://static.hntv.tv/total/jrxl/desc/Mid-AutumnFestival.jpg',
          playUrl:
            'https://media2.hntv.tv/data_01/1/3/2021/09/19/5f60348673298500915b6fc5417cc461.mp4',
          carousel: [
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/1.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/big/1.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/2.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/big/2.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/3.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/big/3.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/4.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/big/4.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/5.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/Mid-AutumnFestival/big/5.jpg`
            }
          ]
        },
        {
          menuTitle: 'Chung Yeung Festival',
          menuName: '重阳节',
          menuIntro: `The Double Ninth Festival is the ninth day of the ninth month of the lunar calendar.In ancient times,folks practiced the customs of climbing high to pray for blessing, worshiping gods and ancestors, and arranging banquets to pray for longevity on the Double Ninth Festival. <br /><br />As the 2021 Chinese Festivals Series wrap up, the story of the Wonderful Tour of Double Ninth Festival starts from the legend of the origin of the Double Ninth Festival. The smart storytelling, rich cultural connotation combined with the ink special effects wined much acclaim from netizens.`,
          active:
            this.$route.params.tabListTitle === 'ChungYeungFestival'
              ? true
              : false,
          menuBg:
            'https://static.hntv.tv/total/jrxl/desc/ChungYeungFestival.jpg',
          playUrl:
            'https://media2.hntv.tv/data_01/1/3/2021/10/13/9a74707679b5776a5b2ad9e623e10fcf.mp4',
          carousel: [
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/1.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/big/1.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/2.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/big/2.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/3.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/big/3.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/4.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/big/4.jpg`
            },
            {
              img: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/5.jpg`,
              imgBig: `https://static.hntv.tv/total/jrxl/desc/carousel/ChungYeungFestival/big/5.jpg`
            }
          ]
        }
      ]
    }
  },
  mounted() {
    switch (this.$route.params.tabListTitle) {
      case 'SpringFestival':
        this.$refs.fullpage.api.silentMoveTo(1, 0)
        break
      case 'LanternFestival':
        this.$refs.fullpage.api.silentMoveTo(2, 0)
        break
      case 'ChingMingFestival':
        this.$refs.fullpage.api.silentMoveTo(3, 0)
        break
      case 'DragonBoatFestival':
        this.$refs.fullpage.api.silentMoveTo(4, 0)
        break
      case 'JulySeventhDay':
        this.$refs.fullpage.api.silentMoveTo(5, 0)
        break
      case 'Mid-AutumnFestival':
        this.$refs.fullpage.api.silentMoveTo(6, 0)
        break
      case 'ChungYeungFestival':
        this.$refs.fullpage.api.silentMoveTo(7, 0)
        break
    }
  },
  methods: {
    imgLoad(e) {
      this.bannerHeight = e.path[0].height
    },
    menuClick(item, index) {
      this.menuList.forEach((i) => {
        i.active = false
      })
      item.active = true
      let tabListTitle = item.menuTitle.replace(/\s+/g, '')
      this.$router.replace({
        name: 'desc',
        params: { tabListTitle }
      })
      this.$refs.fullpage.api.moveTo(index + 1, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100vw;
  height: 100vh;
  position: relative;
  &-bg {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    object-fit: fill;
  }
  &-mask {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }
  &-menu {
    list-style: none;
    color: #ffd9a8;
    width: 435px;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    // align-items: flex-start;
    li {
      display: flex;
      align-items: flex-start;
      flex-direction: row;
      justify-content: flex-start;
      min-height: 80px;
      border-left: 1px dashed #ffd9a8;
      font-size: 18px;
      letter-spacing: 2px;
      font-family: 'Bebas';
      -webkit-font-smoothing: subpixel-antialiased;
      -moz-osx-font-smoothing: grayscale;
      i {
        // display: inline-block;
        cursor: pointer;
        width: 26px;
        height: 26px;
        margin: -13px 0 0 -13px;
        background: url('../assets/img/menu-li.png') center no-repeat;
      }
      i.active {
        background: url('../assets/img/menu-li-active.png') center no-repeat;
      }
      p {
        cursor: pointer;
        margin: -16px 0 0 30px;
      }
      p:hover {
        color: #fff;
      }
      p.active {
        font-size: 34px;
        margin: -30px 0 0 30px;
      }
    }
    li:last-child {
      border-left: none;
      min-height: 21px;
    }
  }
}

.section {
  &-intro {
    margin: 20px 0 30px 0;
    color: #fff;
    font-size: 16px;
    line-height: 24px;
    font-family: 'Myriad Pro';
    text-align: justify;
    text-justify: inter-ideograph;
  }
  &-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    &-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      h5 {
        margin: 0;
        display: inline-block;
        padding: 3px 6px;
        font-family: '宋体';
        font-size: 20px;
        color: #ffd9a8;
        border: 1px solid #ffd9a8;
        border-radius: 5px;
      }
      h1 {
        margin: 0;
        font-family: 'Bebas';
        color: #fff;
        font-size: 42px;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0.8)
        );
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: 2px;
        -webkit-font-smoothing: subpixel-antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }
  }
}

.el-carousel {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
}
.el-carousel__item--card {
  width: 33%;
  height: auto;
}
/deep/ .el-carousel__arrow {
  background-color: rgba(31, 45, 61, 0.3);
}

/deep/ .el-carousel__mask {
  display: none;
}

/deep/ .fp-tableCell {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
